var exports = {
  "Y7": "SidePanelHeaderContainer__ajZcuw",
  "AZ": "headerContentWrapper__6mgoV1",
  "_0": "headerMainSection__T9wO80",
  "VW": "headerContent__j9epsh",
  "r6": "toolbarSection__LUzXsT",
  "gn": "titleContainer__RHbjS2",
  "bM": "repositoryHeaderContainer__kgHtuY",
  "DT": "authorInfoSection__0siimN",
  "fh": "authorName__6jrO7B",
  "o_": "authorNameBold__Ti6ZW_",
  "Os": "authorDetails__Zzfzu4",
  "rL": "headerBottomBorder__ctRe6r",
  "Te": "repositoryIconSection__t0sjal",
  "eI": "repositoryIcon__1qncwP",
  "HI": "toolbarContainer__mN0Nvh",
  "j3": "titleAndEditSection__qVysN7",
  "Dy": "editing__Y2sJOJ",
  "hz": "titleInput__vez4_m",
  "$D": "titleHeading__aP7VQp",
  "KQ": "loadingText__CIur7t",
  "zD": "titleLink__qEEh8T",
  "Pp": "issueNumber__5di6kI",
  "Tb": "editButtonsContainer__7bHJ_4",
  "sy": "titleAndButtonsContainer__vEHTuX",
};

module.exports = exports;
